<template>
  <div class="">
    <h3 class="purple darken-3 white--text rounded text-center py-3 mb-4">
      {{ text }}
    </h3>
  </div>
</template>

<script>
export default {
  name: "PublicBanner",
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped></style>
